module.exports = __webpack_public_path__ + "stickermule-1-181080e533cb49438999ad81f09912d8.webp";